import axios from 'axios'

export const fetchActionPatterns = () => axios.get('/pattern')
